/**
 * 画像ライトボックス（拡大表示）スクリプト
 * 
 * 対象: 固定ページ（/pages/*）のリッチテキストコンテンツ内の画像のみ
 * 
 * 使用方法:
 * - .lightbox-enabled クラスを持つ要素内の画像が対象
 * - または .rte (リッチテキストエディタ) 内の画像
 * - .no-lightbox クラスを追加した画像は対象外
 * 
 * 除外:
 * - ヘッダー、フッター、サイドバー、ナビゲーション
 * - 商品ページのギャラリー
 * - ロゴ、アイコン、背景画像
 */

(function() {
  'use strict';

  // 対象ページかどうかをチェック
  function isTargetPage() {
    const path = window.location.pathname;
    // 固定ページ（/pages/*）のみ対象
    return path.startsWith('/pages/');
  }

  // ライトボックス要素を作成
  function createLightbox() {
    const overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    overlay.innerHTML = `
      <button class="lightbox-close" aria-label="閉じる">×</button>
      <img class="lightbox-image" src="" alt="拡大画像">
      <div class="lightbox-hint">クリックまたはESCキーで閉じる</div>
    `;
    document.body.appendChild(overlay);
    return overlay;
  }

  // ライトボックスを開く
  function openLightbox(overlay, imgSrc, imgAlt) {
    const lightboxImg = overlay.querySelector('.lightbox-image');
    lightboxImg.src = imgSrc;
    lightboxImg.alt = imgAlt || '拡大画像';
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  // ライトボックスを閉じる
  function closeLightbox(overlay) {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // 画像がライトボックス対象かどうかをチェック
  function isLightboxTarget(img) {
    // 除外条件
    const excludeSelectors = [
      'header', '.header', '#header',
      'footer', '.footer', '#footer',
      'nav', '.nav', '.navigation',
      '.sidebar', '#sidebar',
      '.logo', '.site-logo', '.header-logo',
      '.product-media', '.product-gallery',
      '.icon', '.badge', '.button',
      'a[href]', // リンク内の画像は除外
    ];

    // 除外要素の中にいる場合は対象外
    for (const selector of excludeSelectors) {
      if (img.closest(selector)) {
        return false;
      }
    }

    // 小さすぎる画像（アイコン等）は対象外
    if (img.naturalWidth < 100 || img.naturalHeight < 100) {
      return false;
    }

    // .no-lightbox クラスがある場合は対象外
    if (img.classList.contains('no-lightbox')) {
      return false;
    }

    // 対象条件：メインコンテンツ内のリッチテキスト画像
    const includeSelectors = [
      '.rte',                        // リッチテキストエディタ
      '.page-content',               // ページコンテンツ
      '.lightbox-enabled',           // 明示的に有効化
      '.collection-description-content', // コレクション説明
      'main .shopify-section',       // メイン内のセクション
    ];

    for (const selector of includeSelectors) {
      if (img.closest(selector)) {
        return true;
      }
    }

    return false;
  }

  // 初期化
  function init() {
    // 固定ページ以外では初期化しない
    if (!isTargetPage()) {
      return;
    }

    const overlay = createLightbox();
    const closeBtn = overlay.querySelector('.lightbox-close');

    // 画像クリックイベント（イベント委譲）
    document.addEventListener('click', function(e) {
      const img = e.target;
      
      // img要素でない場合はスキップ
      if (img.tagName !== 'IMG') {
        return;
      }

      // ライトボックス対象かチェック
      if (!isLightboxTarget(img)) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      
      // 高解像度版があればそれを使用
      const highResSrc = img.dataset.src || img.dataset.highres || img.src;
      openLightbox(overlay, highResSrc, img.alt);
    });

    // 閉じるボタンクリック
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      closeLightbox(overlay);
    });

    // オーバーレイクリック
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target.classList.contains('lightbox-image')) {
        closeLightbox(overlay);
      }
    });

    // ESCキーで閉じる
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closeLightbox(overlay);
      }
    });

  }

  // DOM読み込み完了後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

